import React, {FC} from 'react'
import {Spinner} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import {COGCardProps} from './types'

const COGCard: FC<COGCardProps> = React.memo(({providers, totalCOG, loading}) => (
  <div className='metric-group-card card h-100'>
    <div className='card-header border-0 pt-5 pb-0'>
      <div className='card-title'>
        <KTSVG
          path='/media/icons/duotune/finance/fin010.svg'
          className='svg-icon-2 me-2 text-cog-orange'
        />
        <h3 className='fw-bold fs-5 mb-0'>Cost of Goods (COG)</h3>
      </div>
    </div>
    <div className='card-body pt-4'>
      {/* Total COG */}
      <div className='text-center mb-4 pb-4 border-bottom'>
        <div className='fs-2x fw-bold cog-total-value'>
          {loading ? <Spinner size='sm' animation='border' /> : `$${totalCOG.toFixed(2)}`}
        </div>
        <div className='fs-8 text-muted fw-semibold'>Total COG</div>
      </div>

      {/* Per Provider Breakdown */}
      <div className='provider-breakdown'>
        <div className='fs-8 text-muted fw-bold text-uppercase mb-3'>Per Provider</div>
        {providers.map((p) => (
          <div
            key={p.provider}
            className='d-flex justify-content-between align-items-center py-2 border-bottom border-gray-100'
          >
            <span className='fs-7 fw-semibold text-gray-700'>{p.provider}</span>
            <span className='fs-6 fw-bold cog-provider-value'>
              {p.loading ? <Spinner size='sm' animation='border' /> : `$${p.cost.toFixed(2)}`}
            </span>
          </div>
        ))}
      </div>
    </div>
  </div>
))

COGCard.displayName = 'COGCard'

export default COGCard
